var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpHeaderService } from 'src/app/shared/service/http-header.service';
import { HttpClient } from '@angular/common/http';
import { HttpClientAbstract } from 'src/app/shared/service/http-client-abstract';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "./http-header.service";
import * as i2 from "@angular/common/http";
var NotificationService = /** @class */ (function (_super) {
    __extends(NotificationService, _super);
    function NotificationService(header, http) {
        var _this = _super.call(this, header, http) || this;
        // SlackURLテストに成功したか否か
        _this.slackUrlTested = false;
        // SlackURLがDBに登録済みか否か
        _this.slackUrlRegisterd = false;
        return _this;
    }
    // new api
    // notificationMethod
    NotificationService.prototype.getNotificationMethods = function () {
        return _super.prototype.requestGet.call(this, 'api/v1/notification_methods')
            .pipe(map(function (res) { return res.body; }));
    };
    NotificationService.prototype.createNotificationMethod = function (method) {
        return _super.prototype.requestPost.call(this, 'api/v1/notification_methods', {
            notification_method: method
        })
            .pipe(map(function (res) { return res.body; }));
    };
    NotificationService.prototype.updateNotificationMethod = function (method) {
        if (!!!method.id) {
            return this.createNotificationMethod(method);
        }
        return _super.prototype.requestPatch.call(this, "api/v1/notification_methods/" + method.id, {
            notification_method: method
        })
            .pipe(map(function (res) { return res.body; }));
    };
    NotificationService.prototype.deleteNotificationMethod = function (method) {
        return _super.prototype.requestPatch.call(this, "api/v1/notification_methods/" + method.id, {
            notification_method: method
        });
    };
    NotificationService.prototype.checkSlackUrlMethod = function (method) {
        return _super.prototype.requestPost.call(this, "api/v1/notification_methods/slack_validity_test", {
            notification_method: method
        })
            .pipe(map(function (res) { return res.body; }));
    };
    // SlackURLテストに成功したか否か、フラグを返す
    NotificationService.prototype.isSlackUrlTested = function () {
        return this.slackUrlTested;
    };
    // DBにSlackURLが登録されているかどうか
    NotificationService.prototype.isRegisteredSlackUrl = function () {
        return this.slackUrlRegisterd;
    };
    // notificationFilters
    NotificationService.prototype.getNotificationFilters = function () {
        return _super.prototype.requestGet.call(this, 'api/v1/notification_filters')
            .pipe(map(function (res) { return res.body; }));
    };
    NotificationService.prototype.createNotificationFilter = function (filter) {
        return _super.prototype.requestPost.call(this, 'api/v1/notification_filters', {
            notification_filter: filter
        })
            .pipe(map(function (res) { return res.body; }));
    };
    NotificationService.prototype.updateNotificationFilter = function (filter) {
        console.log(filter);
        return _super.prototype.requestPatch.call(this, "api/v1/notification_filters/" + filter.id, {
            notification_filter: filter
        })
            .pipe(map(function (res) { return res.body; }));
    };
    NotificationService.prototype.deleteNotificationFilter = function (filter_id) {
        return _super.prototype.requestDelete.call(this, "api/v1/notification_filters/" + filter_id, {
            notification_filter: { id: filter_id }
        })
            .pipe(map(function (res) { return res.body; }));
    };
    NotificationService.ngInjectableDef = i0.defineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(i0.inject(i1.HttpHeaderService), i0.inject(i2.HttpClient)); }, token: NotificationService, providedIn: "root" });
    return NotificationService;
}(HttpClientAbstract));
export { NotificationService };
